import BaseService from "../BaseService";
import _ from "lodash";

class SignupService extends BaseService {
    signupWithPhone = async (info) => {
        var data = await this._api.post("signup/withphone", info);
        return data;
    }
    createWithOTP = async (info) => {
        var data = await this._api.post("signup/createwithotp", info);
        return data;
    }







}
export default SignupService;
